import HistorialUserComponent from "../components/HistorialUser/HistorialUser";

export default function HistorialUser() {
  return <HistorialUserComponent />;
}
